import React, {
  FunctionComponent,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';
import localforage from 'localforage';

import { firmwareApi } from '../../../api/firmwareApi';

// Types and constants
import { FirmwareModel } from '../../../shared/types';

// Components
import FirmwareTable from './FirmwareTable/FirmwareTable';
import { setUsersNames } from '../../../utils/getAuthorizedUserNames';
import { UserContext } from '../../../context/UserContext';
import { hasCMSAccess } from '../../../utils/auth';

const Firmware: FunctionComponent<any> = (props: any): ReactElement => {
  const [firmwares, setFirmwares] = useState<FirmwareModel[]>([]);
  const [openDeleteFirmwareDialog, setOpenDeleteFirmwareDialog] = useState<boolean>(false);
  const [firmwaresToDelete, setFirmwaresToDelete] = useState<FirmwareModel[]>([]);
  const [firmwareIdsToDelete, setFirmwareIdsToDelete] = useState<string[]>([]);

  const user = useContext(UserContext).user;

  const loadFirmwares = async () => {
    let response: FirmwareModel[] = await firmwareApi?.getFirmwares();
    response = response?.map((item) => {
      item.isEditMode = false;
      item.isCreateMode = false;
      item.authorizedUsers = item.authorizedUsers || [];
      item.authorizedRoles = item.authorizedRoles || [];
      return item;
    });

    response = await setUsersNames(response);
    setFirmwares(response);
    localforage.setItem('firmwares', response);
  };

  const deleteHandler = (firmwareIds: string[]) => {
    setOpenDeleteFirmwareDialog(true);
    const fws = firmwares.filter((firmware) => firmwareIds.includes(firmware.id));
    setFirmwaresToDelete(fws);
    setFirmwareIdsToDelete(firmwareIds);
  };

  const deleteFirmware = async () => {
    const promises = [];
    for (let i = 0; i < firmwareIdsToDelete.length; i++) {
      promises.push(firmwareApi.deleteFirmware(firmwareIdsToDelete[i]));
    }

    await Promise.all(promises);
    setOpenDeleteFirmwareDialog(false);
    loadFirmwares();
  };

  const handleClose = () => {
    setOpenDeleteFirmwareDialog(false);
  };

  useEffect(() => {
    if (hasCMSAccess(user)) {
      loadFirmwares();
    }
  }, [user]);

  const firmwareTableProps = {
    firmwareList: firmwares,
    openDeleteFirmwareDialog,
    firmwaresToDelete,
    deleteHandler,
    deleteFirmware,
    handleClose,
  };

  return (
    <div data-testid='firmware-container'>
      <FirmwareTable {...firmwareTableProps} />
    </div>
  );
};

export default Firmware;
